<template>
  <MenuPopup class="min-w-230px">
    <div class="border-b border-border">
      <MenuPopupItem @click.native="toggleModal('importPortfolio')"
                     :mute-inactive="true"
                     class="font-medium">
        <template slot="icon">
          <IconImportFile/>
        </template>
        <template slot="text">{{ $t('importPortfolio') }}</template>
      </MenuPopupItem>
    </div>
    <div class="border-b border-border">
      <MenuPopupItem :mute-inactive="true">
        <template slot="text"><span class="text-text-ternary cursor-auto">{{ $t('manualActions') }}</span></template>
      </MenuPopupItem>
      <MenuPopupItem @click.native="toggleModal('addDealBuy')"
                     :mute-inactive="true"
                     class="font-medium">
        <template slot="icon">
          <IconInvestBuy/>
        </template>
        <template slot="text">{{ $t('addDealBuy') }}</template>
      </MenuPopupItem>
      <MenuPopupItem @click.native="toggleModal('addDealSell')"
                     :mute-inactive="true"
                     class="font-medium">
        <template slot="icon">
          <IconInvestSell/>
        </template>
        <template slot="text">{{ $t('addDealSell') }}</template>
      </MenuPopupItem>
    </div>
    <div class="border-b border-border">
      <MenuPopupItem @click.native="toggleModal('addManualIncome')"
                     :mute-inactive="true"
                     class="font-medium">
        <template slot="icon">
          <IconCoinPlus/>
        </template>
        <template slot="text">{{ $t('addManualIncome') }}</template>
      </MenuPopupItem>
      <MenuPopupItem @click.native="toggleModal('addManualExpense')"
                     :mute-inactive="true"
                     class="font-medium">
        <template slot="icon">
          <IconCoinMinus/>
        </template>
        <template slot="text">{{ $t('addManualExpense') }}</template>
      </MenuPopupItem>
    </div>
    <MenuPopupItem @click.native="toggleModal('transferInBalance')"
                   :mute-inactive="true"
                   class="font-medium">
      <template slot="icon">
        <IconCoinDown/>
      </template>
      <template slot="text">{{ $t('transferIn') }}</template>
    </MenuPopupItem>
    <MenuPopupItem @click.native="toggleModal('transferOutBalance')"
                   :mute-inactive="true"
                   class="font-medium">
      <template slot="icon">
        <IconCoinUp/>
      </template>
      <template slot="text">{{ $t('transferOut') }}</template>
    </MenuPopupItem>
  </MenuPopup>
</template>

<script>
import MenuPopup from "@/components/common/MenuPopup/MenuPopup";
import MenuPopupItem from "@/components/common/MenuPopup/MenuPopupItem";
import IconImportFile from "@/components/icons/IconImportFile";
import {mapMutations} from "vuex";
import IconCoinPlus from "@/components/icons/IconCoinPlus";
import IconCoinMinus from "@/components/icons/IconCoinMinus";
import IconCoinUp from "@/components/icons/IconCoinUp";
import IconCoinDown from "@/components/icons/IconCoinDown";
import IconInvestBuy from "@/components/icons/IconInvestBuy";
import IconInvestSell from "@/components/icons/IconInvestSell";

export default {
  name: "InvestmentNavigationActions",
  components: {
    IconInvestSell,
    IconInvestBuy,
    IconCoinUp,
    IconCoinDown,
    IconCoinMinus,
    IconCoinPlus,
    IconImportFile,
    MenuPopupItem,
    MenuPopup
  },
  methods: {
    ...mapMutations('investments/modals', ['toggleModal'])
  },
  i18n: {
    messages: {
      en: {
        importPortfolio: 'Import report',
        manualActions: 'Add manually:',
        addDealBuy: 'Buy asset',
        addDealSell: 'Sell asset',
        addManualIncome: 'Income',
        addManualExpense: 'Expense',
        transferIn: 'Deposit funds',
        transferOut: 'Withdraw funds',
      },
      ru: {
        importPortfolio: 'Импорт отчета брокера',
        manualActions: 'Добавить вручную:',
        addDealBuy: 'Покупка актива',
        addDealSell: 'Продажа актива',
        addManualIncome: 'Доход',
        addManualExpense: 'Расход',
        transferIn: 'Внесение средств',
        transferOut: 'Вывод средств',
      }
    }
  }
}
</script>